import { useState, ChangeEvent } from "react";
import { SingleSelect } from "../utility/SingleSelect";
import { TestDrive } from "./TestDrive";
import * as FilterStyles from "../Filter.styles";
import * as TableStyles from "../Table.styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TextField from "@material-ui/core/TextField";
import { TestDriveArea } from "./TestDriveArea";
import { TestDriveModal } from "./TestDriveModal";
import { Add } from "@material-ui/icons";
import { DatePicker } from "../utility/DatePicker";
import { isValid } from "date-fns";
import { isYearValid, isNameValid, isManufacturerValid, isModelValid } from "./TestDriveValidators";

const testDrivesSet: TestDrive[] = [
  {
    id: 1,
    car: {
      id: 1,
      photos: ["https://material-ui.com/static/logo_raw.svg"],
      model: {
        id: 1,
        modelName: "focus",
        modelTypes: ["sedan"],
        modelImage: "https://material-ui.com/static/logo_raw.svg",
        manufacturer: "ford"
      },
      equipment: ["ac", "radio"],
      engine: "diesel",
      carType: "sedan",
      color: "red",
      productionDate: new Date(),
      description: "a"
    },
    user: {
      id: 1,
      firstName: "Adam",
      lastName: "Malysz",
      email: "abc@abc.com",
      phoneNumber: "123123123",
      photo: "https://media.thetab.com/blogs.dir/90/files/2020/10/eiddclywsamofb9-819x1024.jpeg",
    },
    date: new Date("10-10-2010")
  },
  {
    id: 2,
    car: {
      id: 3,
      photos: ["data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAANlBMVEX///+/v7+7u7vt7e3z8/P5+fn8/PzAwMDGxsbZ2dnV1dXw8PDDw8P19fXMzMzo6Oji4uLe3t6/AaFhAAAFa0lEQVR4nO2c7XqkIAyFK4riF+L93+wKTqduFRIdBWd63n/77FTgGEICwa8vAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGxQlnKmdxQ/9LJM3blolH0+mLrRWnVVlT0RK7Ks6rRuRjPkxQfr046Nyubx8nG/rzrVmFymHsDZFHW1T4wNcTpdm/5jbEbql/RYKlPpsf0EXcw5gjyFybTpU4/pNXp1kpEsZRHKvLG11Ocr8pClKVKP7Rh5d5EkThb9hlOobC5UZFbl3VZoc7EiTpU69Sj3cIVv3RIlG1KPlM1VvnVDlTdxK+2VvnWtyph6vDSX+9aVKF2eeswEeRVZEqtKc+cYLrqRfGNSj9xLXtG9v4bb+tpURjKrcsdgJZ2RPES5n6+NF5P4VdG38rVF1JjEz43i2vEeikymou7ia8/aXjyDe8S1skutw3+Irk2tyFebWoQVSeNa2eemTq3AJtHj2lIWkxZaVdnOU6x4iC7SClTK1oyN7qq9J3opEFV93WGQtYphkkJ19zWLbc4/JCvbHyXeSoolwh6SnbGXLScx1FtMEBZCvCiLNE33IVosEMcPPopRfZ4eM+LQ6lyOCbYN46EPmEjzqRbyoNurSH+nLO4axL4sKNnOclR27U22iTcNI7Fn8hSpOxuJHZOn/BtWMtGwNWlSdzUe3NRn+AvudYYbtpWpOxoTppf9QzNnMhTWoVjPmjnijimyONArVnyvGU3rehjyYRh1dhtdhFC1GfJ82JnEC0Zy3BLPE1mzXNT78RanfUIv91pLsyMvYcSylJmsHfUQp3gvgKhXL7vgq0JKIoOPep6S9IMxZige/zq5gH4nzzoTmdtOtQ99uCV0giy/DtawVrOTHnT1fdXosYOX8tjvEWK01o3MnVLjLBIvjaVDlNDUUc4szH/bTJN7caqk21hw3u3X/BXavXzeMT4Z3wdeuJNkyyJNQlGc5W/cBxJupKyIXFGa+B/Slb6pNbdPr+EX4BLbfPN/lGRaiiAkKb3PcC/E04SwgU+KZNr5gtzT50ry3hSliXfZca17HbATxde3C7HN+gMqa9mM5I3SxBvYq/CgXYVh/ERJhgdtJaNdCqVJ4XmCTZWCk8NOLUm1fjY1MTlcfZKinnJUE2sm4SpGlcBQJDVhbTJDGsrBuSMG0gqsJfkUvYiGtgL7E+oxB32s/TNqWdMcOz0T1luY3CxZNUVo4olPOOO1dhq3aIsxXmvg1HpIxmyb4aj1VeRWE6f5U7EvisyzGno5pneVthIna6X0mtZQWfXJ1KEQ8wkpHGebeuNdiynPHMnWrd4RY1k7Ftqpi5KIZXlFKBsPZrmKjmPL52HnKiMg68MhArPcYu1MBcd7O00iLjxMTYpg1wWzFH8tK99O7qdJH+o6+9LTOtPjaaLizx16nbNd98+diinJRqJpdynoi/WatQ6cx8hZ52y06fWxgl1YvV7P7d9SZxxubaR/dCI2bifbs8brXQzJaO2Hta6stCGP85WGJ13IBL6pA4nantKtYf0psC866bVzU6+/InYhPe1k7bKzHs6DXVcSlp+Lc9gzDMqfWRfe5jGRtAOzs6PP859v331/Fa/NT7nlFF5nOeeuFxBeDveZwgGChpLqenM4wdvhRA8S8ijslf5sQh6FPvZ8mdIfkUVo3Yf/BPRYPf1OpG+lv3zehvCdQEaazp6zcl4B1GVsixLtUnG50b7oUn8sbutEIabpDr/Lte7wQY32d1lQ7A+1LYstRLYuEUrCsLh5JYSOf+28H7UtgKl0nf7K+xNp9KSLyFRzow9ZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2+AdFqFBandxOZgAAAABJRU5ErkJggg=="],
      model: {
        id: 2,
        modelName: "a8",
        modelTypes: ["sedan"],
        modelImage: "data:image/png;base64,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",
        manufacturer: "audi"
      },
      carType: "sedan",
      equipment: ["AC", "radio"],
      engine: "diesel",
      color: "black",
      productionDate: new Date("10-10-2010"),
      description: "abc"
    },
    user: {
      id: 1,
      firstName: "Adam",
      lastName: "Malysz",
      email: "abc@abc.com",
      phoneNumber: "123123123",
      photo: "https://media.thetab.com/blogs.dir/90/files/2020/10/eiddclywsamofb9-819x1024.jpeg",
    },
    date: new Date("10-10-2011")
  },
  {
    id: 3,
    car: {
      id: 2,
      photos: ["data:image/png;base64,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"],
      model: {
        id: 1,
        modelName: "focus",
        modelTypes: ["sedan"],
        modelImage: "data:image/png;base64,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",
        manufacturer: "ford"
      },
      carType: "sedan",
      equipment: ["AC", "radio"],
      engine: "diesel",
      color: "blue",
      productionDate: new Date("10.10.2001"),
      description: "cba"
    },
    user: {
      id: 2,
      firstName: "Mariusz",
      lastName: "Pudzianowski",
      email: "cba@cba.com",
      phoneNumber: "321321321",
      photo: "https://media.thetab.com/blogs.dir/90/files/2020/10/eiddclywsamofb9-819x1024.jpeg"
    },
    date: new Date("10.10.2011")
  }
];

const TestDrivesBase = (): JSX.Element => {
  const [testDrives, setTestDrives] = useState<TestDrive[]>(testDrivesSet);
  const [filterData, setFilterData] = useState<TestDrive>({
    id: 0,
    user: {
      id: 0,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      photo: "",
    },
    car: {
      id: 0,
      photos: [""],
      carType: "",
      equipment: [""],
      engine: "",
      model: {
        id: 0,
        modelName: "",
        modelTypes: [""],
        modelImage: "",
        manufacturer: ""
      },
      color: "",
      productionDate: new Date(),
      description: ""
    },
    date: new Date()
  });
  const [maxDate, setMaxDate] = useState<Date>(new Date());
  const [selectedTestDrives, setSelectedTestDrives] = useState<TestDrive[]>(testDrives);
  const [modalAddOpen, setModalAddOpen] = useState<boolean>(false);

  const handleFilter = () => {
    const newTDs = testDriveFilter(testDrives);
    setSelectedTestDrives(newTDs);
  };

  const testDriveFilter = (testDrives: TestDrive[]) => {
    return testDrives.filter(td => isYearValid(td, filterData, maxDate) && isNameValid(td, filterData) && isManufacturerValid(td, filterData) && isModelValid(td, filterData));
  };

  const handleFilterManufacturer = (selected: string) => {
    setFilterData({...filterData, car: {...filterData.car, model: {...filterData.car.model, manufacturer: selected}}});
  };

  const handleFilterModel = (selected: string) => {
    setFilterData({...filterData, car: {...filterData.car, model: {...filterData.car.model, modelName: selected}}});
  };

  const handleFilterPerson = () => (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const string = event.target.value.split(" ");
    const newFirstName = string[0];
    const newLastName = string[1];
    setFilterData({...filterData, user: {...filterData.user, firstName: newFirstName, lastName: newLastName || ""}});
  };

  const handleFilterMinDate = (date: Date) => {
    if(isValid(date)) {
      setFilterData({...filterData, date: date});
    }
  };

  const handleFilterMaxDate = (date: Date) => {
    if(isValid(date)) {
      setMaxDate(date);
    }
  };

  const handleChange = (row: TestDrive) => {
    const newTestDrives = testDrives.filter(td => td.id != row.id);
    setTestDrives(newTestDrives);
    setSelectedTestDrives(newTestDrives);
  };

  const handleDelete = (row: TestDrive) => {
    const newTestDrives = testDrives.filter(td => td.id != row.id);
    setTestDrives(newTestDrives);
    setSelectedTestDrives(newTestDrives);
  };

  const getItemsWithEmpty = (collection: string[]) => {
    return ["" as string].concat(Array.from(new Set(collection)).sort());
  };

  const handleCloseAddModal = () => {
    setModalAddOpen(false);
  };

  const handleApplyAddModal = () => {
    setModalAddOpen(false);
  };

  return(
    <div>
      <FilterStyles.FilterHeading>
          Filter by details
      </FilterStyles.FilterHeading>
      <FilterStyles.FilterLine/>
      <FilterStyles.TextfieldContainer>
        <SingleSelect 
          label={"Car manufacturer"} 
          items={getItemsWithEmpty(testDrives.map(td => td.car.model.manufacturer))} 
          handleSelect={handleFilterManufacturer}/>
        <SingleSelect 
          label={"Car model"} 
          items={getItemsWithEmpty(testDrives.map(td => td.car.model.modelName))} 
          handleSelect={handleFilterModel}/>
        <DatePicker
          label="Min Date"
          date={filterData.date}
          handleDateChange={handleFilterMinDate}
        />
        <DatePicker
          label="Max Date"
          date={maxDate}
          handleDateChange={handleFilterMaxDate}
        />
      </FilterStyles.TextfieldContainer>
      <FilterStyles.TextfieldContainer>
        <TextField
          label="Person name"
          onChange={handleFilterPerson()}/>
      </FilterStyles.TextfieldContainer>
      <FilterStyles.FilterButton
        variant="contained"
        color="primary"
        onClick={handleFilter}>
        Apply
      </FilterStyles.FilterButton>
      <FilterStyles.AddButton onClick={() => setModalAddOpen(true)}>
        <Add/>
      </FilterStyles.AddButton>
      <TestDriveModal
        open={modalAddOpen}
        label={"Book a new test drive"}
        testDrive={{
          id: 0,
          user: {
            id: 0,
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            photo: "",
          },
          car: {
            id: 0,
            photos: [""],
            carType: "",
            equipment: [""],
            engine: "",
            model: {
              id: 0,
              modelName: "",
              modelTypes: [""],
              modelImage: "",
              manufacturer: ""
            },
            color: "",
            productionDate: new Date(),
            description: ""
          },
          date: new Date()
        }}
        handleApply={handleApplyAddModal}
        handleClose={handleCloseAddModal}
      />
      <FilterStyles.FilterLine/>
      <TableStyles.StyledTable>
        <Table>
          <TableHead>
            <TableRow>
              <TableStyles.TableHeadRow>Car</TableStyles.TableHeadRow>
              <TableStyles.TableHeadRow>Person</TableStyles.TableHeadRow>
              <TableStyles.TableHeadRow>Date</TableStyles.TableHeadRow>
              <TableStyles.TableHeadRow>Actions</TableStyles.TableHeadRow>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedTestDrives.map((row) => (
              <TestDriveArea 
                key={row.id}
                testDrive={row}
                handleChange={handleChange}
                handleDelete={handleDelete}
              />
            ))}
          </TableBody>
        </Table>
      </TableStyles.StyledTable>
    </div>
  );
};

export { TestDrivesBase };